export default __webpack_public_path__ + "static/media/Warlord's Maxim of Chaos.a0e27660.jpg";